function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h3',[_c('strong',[_vm._v("Front desk")])]),_vm._v(" "),_c('p',[_vm._v("Private Clinics, Beauty Studios, Architecture Studios, Design Studios")]),_vm._v(" "),_c('h3',[_vm._v("Manage and measure online sales funnel")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Track phone calls from website")]),_vm._v(" "),_c('li',[_vm._v("Understand registration desk performance")]),_vm._v(" "),_c('li',[_vm._v("Understand better which digital advertising channels work")]),_vm._v(" "),_c('li',[_vm._v("Measure ROI on advertising")])])])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/use-cases/front-desk","image":"/img/use-cases/u-01.svg","title":"Front desk"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }